import { Delete, Table } from "../Action";
import { DataListType } from "../../types";
import { FormType } from "../../schemas";
import { UseFormReturn } from "react-hook-form";
import { useListFilter } from "../../stores";

type Type = {
    isLoading: boolean
    refetch?: () => void
    data: DataListType[]
    method: UseFormReturn<FormType>
}

export function ContentListSection({ 
    isLoading, 
    refetch, 
    data,
    method
}: Type) {

    const { filter } = useListFilter();

    return (
        <div>
            <div className="flex justify-end mb-2">
                <Delete
                    refecth={refetch}
                />
            </div>
            <div className="overflow-auto max-h-[calc(100svh-620px)]">
                <Table
                    data={data}
                    isLoading={isLoading}
                    method={method}
                    start_date={filter.date_start}
                    end_date={filter.date_end}
                    isEdit
                    refecth={refetch}
                />
            </div>
        </div>
    );
}